module.exports = __webpack_public_path__ + "media/images/credit_cards/JCB-db45fb5fe70669132fb2c9c6c3e1a292.png";